module.exports = __webpack_public_path__ + "static/media/Ownership-A.c53ec30c.png";